import {
    FETCH_COUNTRY_SHORT_CODE,
    FETCH_COUNTRY_SHORT_CODE_SUCCESS,
    FETCH_COUNTRY_SHORT_CODE_FAILS,
    ASSIGN_COUNTRY_SHORT_CODE,
    FETCH_IPLOCATION_SUCCESS,
    FETCH_IPLOCATION_FAILS,
} from './locationActionTypes';
import { getLocationDetails, getIPLocation } from '../../api/getLocationDetails';
import { getDetailsFromPlaceID, getLatLngfromPlaceId, getLatLngByAddress } from '../../api/getDetailsFromPlaceID';
import { defaultCountry, defaultShortCountryCode, defaultCurrency, COUNTRY_CODES } from '../../components/Common/constants';
import { FALLBACK_COUNTRIES, findCountryByCode, getDefaultCountry } from '../../utils/country';


// export const getCountryCodes = (lat, long) => {
//   return (dispatch) => {
//     // Dispatch an action to indicate the start of the process
//     dispatch({
//       type: FETCH_COUNTRY_SHORT_CODE,
//     });

//     getLocationDetails(lat, long)
//       .then((res) => {
//         console.log('This is response data duda =======>', res.data)
//         const shortCode = extractShortCode(res.data);

//         //temp
//         let tempCountry = shortCode;
//         if (shortCode === 'AUS') {
//           tempCountry = 'Australia';
//         }

//         const currency = currencyFromCountryCode(shortCode);
//         sessionStorage.setItem('countryShortCode', shortCode);
//         sessionStorage.setItem('currency', currency);
//         dispatch({
//           type: FETCH_COUNTRY_SHORT_CODE_SUCCESS,
//           payload: {
//             country_shortCode: shortCode === 'SG' || shortCode === 'LK' || shortCode === 'AUS' ? shortCode : 'AUS',
//             country_longCode: extractLongCode(res.data),
//             currency: currencyFromCountryCode(shortCode),
//             tempCountry,
//           },
//         });
//       })
//       .catch((error) => {
//         dispatch({
//           type: FETCH_COUNTRY_SHORT_CODE_FAILS,
//           payload: error,
//         });
//       });
//   };
// };

/**
 * Puts a market into Redux and session storage, and points the map at it.
 *
 * @param country registry entry `{ code, name, currency, lat, lng }`
 */
export const setActiveCountry = (country) => {
    return (dispatch, getState) => {
        if (!country?.code) {
            return;
        }

        const currentCode = getState()?.locationMeta?.data?.country_shortCode;
        if (currentCode && currentCode.toUpperCase() === String(country.code).toUpperCase()) {
            return;
        }

        dispatch({ type: FETCH_COUNTRY_SHORT_CODE });

        const currency = country.currency || currencyFromCountryCode(country.code);

        sessionStorage.setItem('countryShortCode', country.code);
        sessionStorage.setItem('currency', currency);

        if (country.lat != null && country.lng != null) {
            dispatch(browserLocation(country.lat, country.lng));
        }

        dispatch({
            type: FETCH_COUNTRY_SHORT_CODE_SUCCESS,
            payload: {
                country_shortCode: country.code,
                country_longCode: country.name,
                currency,
                tempCountry: country.code
            }
        });
    };
};

/**
 * Resolves a market by its short code against the registry passed in, falling back to the
 * bundled constants when the registry has not loaded.
 */
export const getCountryCodes = (countryShortCode, countries = []) => {
    return dispatch => {
        const fromRegistry = findCountryByCode(countries, countryShortCode);
        if (fromRegistry) {
            dispatch(setActiveCountry(fromRegistry));
            return;
        }

        const fallback = findCountryByCode(FALLBACK_COUNTRIES, countryShortCode)
            || getDefaultCountry(FALLBACK_COUNTRIES);
        dispatch(setActiveCountry(fallback));
    };
};


export const assignCountryCode = (shortCode, country) => {
    return {
        type: ASSIGN_COUNTRY_SHORT_CODE,
        payload: {
            country_shortCode: shortCode || defaultShortCountryCode,
            country_longCode: country || defaultCountry,
            currency: currencyFromCountryCode(shortCode)
        }
    };
};

export const assignDefaultCountryCode = () => {
    return {
        type: ASSIGN_COUNTRY_SHORT_CODE,
        payload: {
            country_shortCode: defaultShortCountryCode,
            country_longCode: defaultCountry,
            currency: defaultCurrency
        }
    };
};

export const browserLocation = (lat, lng) => {
    return dispatch => {
        const fallback = getDefaultCountry(FALLBACK_COUNTRIES);
        const location = {
            lat: lat != null ? lat : fallback?.lat,
            lng: lng != null ? lng : fallback?.lng
        };

        sessionStorage.setItem('lat', location.lat);
        sessionStorage.setItem('lng', location.lng);
        dispatch({
            type: FETCH_IPLOCATION_SUCCESS,
            payload: { location }
        });
    }
}

// export const getIpLocation = () => {
//             const sriLankaCoordinates = {
//                 location : {
//                     lat: 6.901608599999999,     
//                     lng: 80.0087746 
//                 }
           
//         };
//         return dispatch => {
//         getIPLocation()
//             .then(res => {
//         sessionStorage.setItem('lat', res.data.location.lat);
//         sessionStorage.setItem('lng', res.data.location.lng);
//         dispatch({
//             type: FETCH_IPLOCATION_SUCCESS,
//             payload: res.data
//                 });
//             })
//             .catch(error => {
//                 dispatch({
//                     type: FETCH_IPLOCATION_FAILS,
//                     payload: sriLankaCoordinates
//         });
//     })
//     }
// }

export const getIpLocation = () => {
    return dispatch => {
        // Always use Sri Lanka's coordinates
        const sriLankaCoordinates = {
            lat: 6.901608599999999,     
            lng: 80.0087746 
        };

        // Set the coordinates in sessionStorage
        sessionStorage.setItem('lat', sriLankaCoordinates.lat);
        sessionStorage.setItem('lng', sriLankaCoordinates.lng);

        // Dispatch success with Sri Lanka coordinates
        dispatch({
            type: FETCH_IPLOCATION_SUCCESS,
            payload: {
                location: sriLankaCoordinates
            }
        });
    };
};

const extractShortCode = (result) => {
    if (result.status = 'ok') {
        let locationComponent = result.results.find(res => res.types.includes('country'))
        switch (locationComponent.address_components[0].short_name) {
            case 'LK':
            case 'SG':
                return locationComponent.address_components[0].short_name;
            default:
                return 'AUS';
        }
    }
}

const extractLongCode = (result) => {
    if (result.status = 'ok') {
        let locationComponent = result.results.find(res => res.types.includes('country'))
        switch (locationComponent.address_components[0].long_name) {
            case 'Sri Lanka':
                return 'Sri Lanka'
            case 'Singapore':
                return 'Singapore'
            case 'Australia':
                return 'Australia'
            default:
                return 'Singapore';
        }

    }
}
const currencyFromCountryCode = (countryCode) => {
    switch (countryCode) {
        case 'LK':
            return 'LKR';
        case 'SG':
            return 'SGD'
        case 'AUS':
            return 'AUD'
        default:
            return 'SGD';
    }
}

export const getLocationDetailsOfSelected = placecId => {
    return dispatch => {
        dispatch({
            type: FETCH_COUNTRY_SHORT_CODE
        });
        getDetailsFromPlaceID(placecId).
            then(res => {

                let shortCode = res[0].address_components.find(response => response.types.includes('country')).short_name;
                let longCode = res[0].address_components.find(response => response.types.includes('country')).long_name;
                sessionStorage.setItem('countryShortCode', shortCode);
                sessionStorage.setItem('currency', currencyFromCountryCode(shortCode));

                return {
                    country_shortCode: shortCode || defaultShortCountryCode,
                    country_longCode: longCode || defaultCountry,
                    currency: currencyFromCountryCode(shortCode)
                }
            }).then(res => {
                fetchCountrySortCode(res)
            })

            .catch(error => {
                dispatch({
                    type: FETCH_COUNTRY_SHORT_CODE_FAILS,
                    payload: error
                });
            });
    };
};

/**
 * Activates a market given its long name, for example "Sri Lanka" or "Singapore".
 */
export const fetchCountrySortCode = ({ country_longCode } = {}, countries = []) => {
    return dispatch => {
        const pool = countries.length > 0 ? countries : FALLBACK_COUNTRIES;
        const matched = pool.find(country => country.name === country_longCode)
            || getDefaultCountry(pool);

        dispatch(setActiveCountry(matched));
    };
};


export const getSuggestions = (lat, lng, country) => {
    return (dispatch, getState, { axiosInstance }) => {
        sessionStorage.setItem('currency', currencyFromCountryCode(country));
        if(lat && lng){
            dispatch(browserLocation(lat, lng));
        }else{
            for(let details in COUNTRY_CODES){
                if(COUNTRY_CODES[details].country_shortCode === country) {
                    const {lat, lng } = COUNTRY_CODES[details]
                    dispatch(browserLocation(lat, lng));
                }
                
            }
        }   
    }
}

export const getLatLngByPlaceId = (placeId) => {
    return dispatch => {
        getLatLngfromPlaceId(placeId)
            .then((res) => {
                dispatch(browserLocation(res.lat, res.lng));
            })

    }
}